export default (id) => {
  if (typeof id !== 'string') return;
  const element = document.getElementById(id);
  element.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
};
